<script setup lang="ts">
    import { useI18n } from 'vue-i18n'

    const { t: $t } = useI18n({
        useScope: 'global',
    })
</script>

<template>
    <div
        class="flex flex-col items-center justify-center w-full text-md p-md leading-normal">
        <div class="mb-4">
            <VvIcon name="ri:alert-line" class="text-32 text-word-2" />
        </div>
        <strong class="font-bold">
            {{ $t('message.warning') }}
        </strong>
        <div class="text-smaller text-word-3">
            {{ $t('message.readError') }}
        </div>
    </div>
</template>
